import { render } from "./pageAll.vue?vue&type=template&id=81e7f8e8&scoped=true"
import script from "./pageAll.vue?vue&type=script&lang=js"
export * from "./pageAll.vue?vue&type=script&lang=js"

import "./pageAll.vue?vue&type=style&index=0&id=81e7f8e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e7f8e8"]])

export default __exports__